export default "__VITE_PUBLIC_ASSET__f2e3cfbd__"